export default __webpack_public_path__ + "static/media/user_01.cd00277d.jpg";